// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__jqUAW","pageItem":"Pagination_pageItem__hwWmy","pageLink":"Pagination_pageLink__X5y_p","active":"Pagination_active__w5FWu"};